import {RemoteCollectionStore, StoreBuilder} from '@softline/core';
import {RetourenArtikelDetail} from '../data/retouren-artikel-detail';

export const RetourenArtikelDetailStore =
  new StoreBuilder(RemoteCollectionStore.create<RetourenArtikelDetail>())
    .value
